import Vue from 'vue';
import {
 checkBinding, validateSmsAndBinding, checkSMS, checkIsMember, getMemberCrmInfo, sendSmsValidateIndependant, sendBindingIndependant
} from '../../../services/crmService/signUpService';
import {
  getStorePersonnel
} from '../../../services/personnelService/storeService';

import {
  getStores
} from '../../../services/storeMapService/storeService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  storeDropdown: [],
  storePersonnelDropdown: []
};

// getters
const getters = {};

// actions
const actions = {
  // 驗證綁定狀態
  async checkBindingHandler() {
    const data = await checkBinding();
    return data;
  },
  // 傳送簡訊驗證
  async sendSmsValidateHandler({}, mobile) {
    const data = await sendSmsValidateIndependant({ mobile });
    return data;
  },
  // 驗證簡訊驗證碼
  async validateSmsAndBindingHandler({}, validateInfo) {
    const data = await validateSmsAndBinding(validateInfo);
    return data;
  },
  // 檢查簡訊驗證碼
  async checkSMSHandler({}, info) {
    const data = await checkSMS(info);
    return data;
  },
  // 檢查是否已有會員資料
  async checkIsMemberHandler({}, validateInfo) {
    const data = await checkIsMember(validateInfo);
    return data;
  },
  // 取得現有會員資料
  async getMemberCrmInfoHandler({}, mobile) {
    const data = await getMemberCrmInfo(mobile);

    return data;
  },
  // 取得店舖下拉
  async getStoresHandler({ commit }, validateInfo) {
    const data = await getStores(validateInfo);
    commit('setStoreDropdown', data.data);
    return data;
  },
  // 取得店舖顧問
  async getStorePersonnelHandler({ commit }, mobile) {
    const data = await getStorePersonnel(mobile);
    commit('setStorePersonnelDropdown', data.data);
    return data;
  },
  // 客制綁定
  async sendBindingHandler({ commit }, info) {
    const data = await sendBindingIndependant(info);
    return data;
  }
};

// mutations
const mutations = {
  setStoreDropdown(state, data) {
    Vue.set(state, 'storeDropdown', data.data);
  },
  setStorePersonnelDropdown(state, data) {
    Vue.set(state, 'storePersonnelDropdown', Object.keys(data.personnel).map((key) => data.personnel[key]));
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
